import { useIntl } from 'react-intl';
import { IBudgetVersionService } from '../../../../models/budgetV2';
import { ITruckerPayPlanData } from '../../../../models/truckerPayPlan';
import { CoverageBadge } from '../../components/CoverageBadge';
import { BudgetCurrencyInput } from '../../components/budgetInputs/BudgetCurrencyInput';
import { formatNumberToCurrency } from '../../../../utils/stringUtils';

interface IServicesSummaryProps {
	service: IBudgetVersionService;
	serviceIndex: number;
	truckerPay?: ITruckerPayPlanData | undefined
}

export const ServiceSummary = (props: IServicesSummaryProps) => {
	const intl = useIntl();
	
	const calculatedSubtotal = () => {
		return (props.service.serviceItems ?? []).reduce((sum, item) => {
			if (item.isCovered === true || item.removed === true) return sum;
			return sum + ((item.quantity ?? 0) * (item.value ?? 0) * (1 - (item.discount ?? 0) / 100));
		}, 0);
	};

	const balance = props.truckerPay?.availableCoverageBalance ?? 0;

	const budgetHasProductWithoutCoverage = props.service.serviceItems?.some(item => !item.isCovered);

	const amountToBePaid = calculatedSubtotal() - balance < 0 ? 0 : calculatedSubtotal() - balance;

	return (
		<div className={`display-flex justify-content-start align-items-center border padding-y-25 padding-x-15 border-gray-200 rounded-md my-6`}>
			<div className='display-flex align-items-center'>
				<p className='text-medium text-size-16 margin-right-10'>{intl.formatMessage({ id: 'intl-msg:budgets.sobMedida' })}</p>
				<span className="badge badge-muted text-size-14 text-color-darkest margin-right-10">
					{props.service.name?.trim() || props.service.id}
				</span>
				<div className='width-150 margin-right-10'>
					<CoverageBadge isCovered={!budgetHasProductWithoutCoverage} notCoveredReason={''} />
				</div>
				<p className='text-size-16 text-color-darker'>{intl.formatMessage({ id: 'intl-msg:budgets.toBeUsedBalance' })}</p>
				<div className='width-150'>
					<BudgetCurrencyInput
						ref={null}
						value={''}
						onChange={(value) => { }}
						disabled={false}
						isRemoved={false}
						isChanged={false}
					/>
				</div>
			</div>

			<div className='display-flex flex-column width-300 gap-5 '>
				<div className='display-flex justify-content-end gap-5 text-[#2A374099] text-medium'>
					<p className='margin-0'>{intl.formatMessage({ id: 'intl-msg:budgets.serviceSubtotal' })}:</p>
					<p className='margin-0'>{formatNumberToCurrency(calculatedSubtotal())}</p>
				</div>
				{budgetHasProductWithoutCoverage ? (
					<>
						<div className='display-flex justify-content-end gap-5 text-color-success text-medium'>
							<p className='margin-0'>{intl.formatMessage({ id: 'intl-msg:budgets.usedBalance' })}:</p>
							<p className='margin-0'>{formatNumberToCurrency(balance)}</p>
						</div>
						<div className='display-flex justify-content-end gap-5 text-color-darkest text-medium'>
							<p className='margin-0'>{intl.formatMessage({ id: 'intl-msg:budgets.toBePaid' })}:</p>
							<p className='margin-0'>{formatNumberToCurrency(amountToBePaid)}</p>
						</div>
					</>
				) : null}
			</div>
		</div>
	);
};
